import { CssBaseline } from '@mui/material';
import * as React from 'react';
import { styled } from '@mui/material/styles';

const Root = styled('div')`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;

const AuthLayout = ({ children }: React.PropsWithChildren) => (
  <Root>
    <CssBaseline />
    {children}
  </Root>
);

export default AuthLayout;
